import { render, staticRenderFns } from "./AddStakeholder.vue?vue&type=template&id=7f6c41a6"
import script from "./AddStakeholder.vue?vue&type=script&lang=js"
export * from "./AddStakeholder.vue?vue&type=script&lang=js"
import style0 from "./AddStakeholder.vue?vue&type=style&index=0&id=7f6c41a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports